// Modification provided by Searchanise team. With any questions, contact us at feedback@searchanise.io

/*
This code translates values of the filters based on metafieds.
In the settings section, there is a filterTranslation object that contains all translation data. 

Between the filterTranslation object curly braces, you should place the name of the filter in the target language. For example:

"TEST FILTER": {},

You can add more filters following the same pattern:

"TEST FILTER 1": {},
"TEST FILTER 2": {},

Filter title you use should match the one from your admin panel. The text is case-sensitive.

Between the filter curly braces, you can place the pair of the original filter value text and translated text. For example: 

"TEST FILTER": {
    "original text": "translated text",
}

Each pair should be placed on the new line, each line should end with a comma.
The filter values are case-insensitive.
*/

// SETTINGS START

let filterTranslation = {
    "Colour": {
        "Brown": "Marrone",
        "Orange": "Arancione",
    },
    "Sport": {
        "Baseball": "Baseball",
        "Basketball": "Basketball",
},
}
// SETTINGS END. DON'T EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

        if (Shopify.locale != 'it') { return }

        function translateInFilter() {
            let filterTitleSelector = $('.snize-filters-dropdown-title').length ? '.snize-filters-dropdown-title' : '.snize-product-filters-title';
            for (let filterTitle of $(filterTitleSelector)) {
                let formattedFilterTitle = $('.snize-filter-selected-variants-count', filterTitle).length ? $(filterTitle).text().replace($('.snize-filter-selected-variants-count', filterTitle).text(), '').trim() : $(filterTitle).text().trim();
                if (Object.keys(filterTranslation).includes(formattedFilterTitle)) {
                    let filter = 
                    $(filterTitleSelector).closest('.snize-product-filters-block').length 
                    ? $(filterTitleSelector).closest('.snize-product-filters-block') // desktop sidebar filter 
                    : $(`${filterTitleSelector} + .snize-filters-dropdown-content`).length 
                    ? $(`${filterTitleSelector} + .snize-filters-dropdown-content`) // desktop top filter
                    : $(filterTitleSelector).closest('.snize-product-filters-header').next(); // mobile filter
                    let filterTranslationData = filterTranslation[formattedFilterTitle];
                    let filterContainerSelector = $('.snize-product-color-filter', filter).length ? '.snize-product-color-filter' : '.snize-product-filters-list';
                    for (let filterValue of $(`${filterContainerSelector} li`, filter)) {
                        let filterValueText = $('.snize-product-filters-checkbox', filterValue).attr('data-se-facet-value-title');
                        if (filterValueText) {
                            let translation = filterTranslationData[filterValueText] || filterTranslationData[filterValueText.toLowerCase()];
                            if (translation) {
                                if ($('label > .needsclick', filterValue).length) {
                                    let filterCount = $('label > .needsclick .snize-filter-variant-count', filterValue).text();
                                    if (!filterCount) {
                                        filterCount = '';
                                    }
                                    $('label > .needsclick', filterValue).text(translation);
                                    if (!$('label > .needsclick > span', filterValue).length) {
                                        $('label > .needsclick', filterValue).append(`<span class="snize-filter-variant-count" aria-hidden="true">${filterCount}</span>`);
                                    } else {
                                        $('label > .needsclick > span', filterValue).text(filterCount);
                                    }
                                } else if ($('.snize-color-name', filterValue).length) {
                                    $('.snize-color-name', filterValue).text(translation);
                                    $('.needsclick', filterValue).attr('title', translation);
                                }
                            }
                        }
                    }
                }
            }
        }

        function translateInClearFilter() {
            for (let filterValue of $('.snize-clear-the-filter')) {
                for (let filter of Object.values(filterTranslation)) {
                    let translation = filter[$(filterValue).text()] || filter[$(filterValue).text().toLowerCase()];
                    if (translation) {
                        $(filterValue).text(translation);
                    }
                }
            }
        }

    
        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            translateInFilter();
            translateInClearFilter();
        });
    })(window.Searchanise.$);
});